import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    icon: {
      height: 24,
      width: 24,
      verticalAlign: 'middle',
    },
    logo: {
      height: 56,
      width: 56,
      marginRight: 'auto',
      marginLeft: 'auto',
      verticalAlign: 'middle',
    },
  });

/**
 * Displays an icon corresponding the product property
 */
const ProductIcon = ({
  product, 
  classes, 
  logo=false, 
  ...props
}) => <img 
    src={product.iconUrl} 
    alt={product.name}
    className={
      logo 
      ? classes.logo 
      : classes.icon
    }
    {...props}
  />


export default withStyles (styles) (ProductIcon); 


// WEBPACK FOOTER //
// ./src/components/products/ProductIcon.js